






























import { Component } from "vue-property-decorator";

import { mixins } from "vue-class-component";

import {
  LayoutStore,
  CanopyStore,
  FrameStore,
  BaseStore,
  ShapeStore
} from "@/mixins/store";

import { Auth } from "@/mixins/auth";

import { ConfigCreator } from "@/mixins/configurator";
import { Preset } from "@/models/configurator/configurator_options";
import { ClearAllPresetDesigns } from "@/mixins/helpers";

@Component
export default class StartOverModal extends mixins(
  LayoutStore,
  CanopyStore,
  FrameStore,
  BaseStore,
  ShapeStore,
  Auth,
  ConfigCreator,
  ClearAllPresetDesigns
) {
  /**

   * Erase all values in store & redirect to first tab

   */

  protected goToMenu(): void {
    this.addFileBeingEditedId("");
    this.clearAllPresetDesigns();
    const loader = this.$loading.show(
      { opacity: 1 },

      { before: this.$createElement("h1", "Loading...") }
    );
    setTimeout(() => {
      loader.hide();
      this.$router.push("/collectionmenu");
    }, 1000);
  }

  protected async startOver(): Promise<void> {
    this.addFileBeingEditedId("");
    this.clearAllPresetDesigns();
    const loader = this.$loading.show(
      { opacity: 1 },
      { before: this.$createElement("h1", "Loading...") }
    );
    const defaultFile = this.collection.config_file![0];
    await this.transformConfigFileAndSaveToStore(defaultFile);
    await this.transformDataToViewerJson();
    this.$router.push("/designer");
    setTimeout(() => {
      this.$router.go(0);
    }, 500);
  }
}
